/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@chakra-ui/react';
import { Labeled } from '../../../../../packages/ui/components/molecules/Labeled';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { useState, ReactNode } from 'react';
import { BookCard } from './BookCard';

interface HorizontalBooksProps {
  name: string;
  description: string;
  hookApi: any;
  showMore?: () => void;
  params: any;
  hideIfEmpty?: boolean;
  receivedBook?: boolean;
}

interface SliderComponentProps {
  children: (props: { currentSlide: number }) => ReactNode;
  name: string;
  description: string;
  showMore?: () => void;
  size?: number;
}

export const SliderComponent: React.FC<SliderComponentProps> = ({
  size = 1,
  children,
  name,
  description,
  showMore,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderSettings = (slidesToShow: number, centerPadding: string) => ({
    infinite: slidesToShow === 1 && size > 1,
    centerMode: slidesToShow === 1,
    centerPadding,
    slidesToShow,
    initialSlide: 0,
    speed: 500,
    beforeChange: (_: number, next: number) => setCurrentSlide(next),
  });

  return (
    <Labeled
      showMore={showMore}
      paddingLeft={'5%'}
      paddingRight={{ base: '0%', md: '5%' }}
      label={name}
      paddingRightActive={'5%'}
      labelColor="rgba(0,0,0,0.6)"
      labelSize={'20px'}
      helpText={description}
    >
      <Box display={{ base: 'none', md: 'block' }} overflow="hidden" width="100%">
        <Slider {...sliderSettings(6, '80px')}>{children({ currentSlide })}</Slider>
      </Box>
      <Box display={{ base: 'block', md: 'none' }} overflow="hidden" width="100%">
        <Slider {...sliderSettings(1, '90px')}>{children({ currentSlide })}</Slider>
      </Box>
    </Labeled>
  );
};

export const HorizontalBooks: React.FC<HorizontalBooksProps> = ({
  name,
  hideIfEmpty,
  hookApi,
  description,
  showMore,
  params,
  receivedBook,
}) => {
  const { data } = hookApi(params);

  let books = data?.results || [];

  if (params?.sortByName === 'true') {
    const order = [
      'Época Negócios',
      'Pequenas Empresas & Grandes Negócios',
      'Galileu',
      'Marie Claire',
      'Auto Esporte',
      'Globo Rural',
    ];
    const orderedBooks = order
      .map((name) => books.find((b: any) => b.name?.toLowerCase() === name.toLowerCase()))
      .filter(Boolean);
    const remainingBooks = books.filter(
      (b: any) => !order.some((name) => b.name?.toLowerCase() === name.toLowerCase())
    );
    books = [...orderedBooks, ...remainingBooks];
  }

  if (books.length === 0 && hideIfEmpty) {
    return null;
  }

  return (
    <SliderComponent size={books.length || 1} name={name} description={description} showMore={showMore}>
      {({ currentSlide }) =>
        books.map((book: any, index: number) => (
          <BookCard showBestSellersTag={book.isBestSeller} receivedBook={receivedBook} key={book.id} book={book} isActive={currentSlide === index} />
        ))
      }
    </SliderComponent>
  );
};
